import { render } from "./howWeDoIt.vue?vue&type=template&id=5b5a782d&scoped=true"
import script from "./howWeDoIt.vue?vue&type=script&lang=js"
export * from "./howWeDoIt.vue?vue&type=script&lang=js"

import "./howWeDoIt.vue?vue&type=style&index=0&id=5b5a782d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\amaan\\encanto-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b5a782d"]])

export default __exports__